import { NotificationT } from 'lib-knowledge-remote-types/general.types';
import { createContext } from 'react';

export type { NotificationT };

export type NotificationContextValue = (props: NotificationT) => void;

const NotificationContext = createContext<NotificationContextValue>((props) => {
  // eslint-disable-next-line no-console
  console.log('Notification: ', props);
});

NotificationContext.displayName = 'NotificationContext';

export { NotificationContext };
